// ! Copyright (c) 2024, Brandon Ramirez, brr.dev

import { ConsoleGameTemplate } from '../../components/templates';

import './LookingGlass.scss';
import { ThroughTheLookingGlassDisc } from '@zenith-game/through-the-looking-glass';

export interface LookingGlassProps {}

export default function LookingGlassContainer(_props: LookingGlassProps) {
    return <ConsoleGameTemplate gameDisc={ThroughTheLookingGlassDisc} />;
}
